export default __webpack_public_path__ + "static/media/mckesson-corporation-logo.6966a929.png";